import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Grid, Group, Paper, Stack, Text, Tooltip } from '@mantine/core';
import {
  IconTrash,
  IconMessage2,
  IconSettings,
  IconLockOpen,
  IconBrandTelegram,
} from '@tabler/icons-react';

import { useGetManagers } from '../api/getManagers';
import { useRemoveManager } from '../api/removeManager';

import { AddModal } from './AddModal';
import { ConfigModal } from './ConfigModal';
import { PagesModal } from './PagesModal';
import { SetPasswordModal } from './SetPasswordModal';
import { TelegramModal } from './TelegramModal';

import { AddButton } from '@/components';
import { ConfirmModal } from '@/components/Modals/Confirm';
import { Departments } from '@/types';

type Props = {
  department: Departments;
};

export const ManagersList = ({ department }: Props) => {
  const { data, isLoading } = useGetManagers({ department });
  const removeManager = useRemoveManager();
  const { managers = [] } = data || {};

  return (
    <div>
      <Grid columns={3}>
        {managers.map((manager) => (
          <Grid.Col span={1} key={manager._id}>
            <Paper shadow="md" radius="md" p="md">
              <Stack>
                <Text size="sm">{manager.username}</Text>
                <Group>
                  <ActionIcon
                    variant="filled"
                    onClick={() => NiceModal.show(ConfigModal, { manager, department })}
                    radius="md"
                  >
                    <Tooltip label="Manager Information">
                      <IconSettings />
                    </Tooltip>
                  </ActionIcon>
                  <ActionIcon
                    variant="filled"
                    onClick={() => NiceModal.show(PagesModal, { manager, department })}
                    radius="md"
                  >
                    <Tooltip label="Manager Pages">
                      <IconMessage2 />
                    </Tooltip>
                  </ActionIcon>
                  <ActionIcon
                    variant="filled"
                    onClick={() => NiceModal.show(SetPasswordModal, { manager, department })}
                    radius="md"
                  >
                    <Tooltip label="Manager Password">
                      <IconLockOpen />
                    </Tooltip>
                  </ActionIcon>
                  <ActionIcon
                    variant={manager.telegram ? 'filled' : 'light'}
                    onClick={() => NiceModal.show(TelegramModal, { manager, department })}
                    radius="md"
                  >
                    <Tooltip label={manager.telegram ? 'Telegram linked' : 'Link telegram'}>
                      <IconBrandTelegram />
                    </Tooltip>
                  </ActionIcon>
                  <ActionIcon
                    variant="filled"
                    onClick={() => {
                      NiceModal.show(ConfirmModal, {
                        title: 'Remove manager?',
                        onSuccess: () => removeManager.mutate({ managerId: manager._id }),
                      });
                    }}
                    radius="md"
                  >
                    <Tooltip label="Remove manager">
                      <IconTrash />
                    </Tooltip>
                  </ActionIcon>
                </Group>
              </Stack>
            </Paper>
          </Grid.Col>
        ))}
      </Grid>
      <AddButton isLoading={isLoading} onClick={() => NiceModal.show(AddModal, { department })} />
    </div>
  );
};
